<template>
  <div
    class="bg-white dark:bg-dark-surface p-6 rounded-3xl border border-slate-100 dark:border-white/5 shadow-xl shadow-slate-200/50 dark:shadow-none transition-all duration-300 relative overflow-hidden group"
    :class="{ 'cursor-pointer hover:-translate-y-1': stat.link && !loading }"
    @click="!loading && stat.link ? $router.push(stat.link) : null"
  >
    <!-- Background glow -->
    <div
      class="absolute -top-4 -right-4 w-20 h-20 bg-primary/5 rounded-full blur-2xl group-hover:bg-primary/10 transition-all"
    ></div>

    <!-- Skeleton loader state -->
    <div v-if="loading" class="animate-pulse space-y-4 relative z-10">
      <div class="flex items-center gap-4">
        <div
          class="w-12 h-12 bg-slate-200 dark:bg-dark-input/50 rounded-2xl"
        ></div>
        <div class="space-y-2 flex-1">
          <div class="h-2 bg-slate-200 dark:bg-dark-input rounded w-16"></div>
          <div class="h-4.5 bg-slate-200 dark:bg-dark-input rounded w-24"></div>
        </div>
      </div>
      <div class="h-2 bg-slate-200 dark:bg-dark-input rounded w-32 mt-2"></div>
    </div>

    <!-- Normal state -->
    <template v-else>
      <div class="flex items-center gap-4 relative z-10">
        <div
          :class="`w-12 h-12 flex items-center justify-center text-2xl ${stat.color}`"
        >
          <i :class="stat.icon"></i>
        </div>
        <div>
          <p
            class="text-[10px] font-black text-slate-400 uppercase tracking-widest"
          >
            {{ $t(stat.label) }}
          </p>
          <h3 class="text-2xl font-black mt-0.5">{{ formattedValue }}</h3>
        </div>
      </div>

      <div class="mt-4 flex items-center gap-2 relative z-10">
        <span
          class="text-[10px] font-black px-2 py-0.5 rounded-full bg-green-500/10 text-green-500"
          >+12.5%</span
        >
        <span
          class="text-[10px] text-slate-400 font-bold uppercase tracking-tighter"
          >{{ $t("vs_last_month") }}</span
        >
      </div>
    </template>
  </div>
</template>

<script>
import { formatCurrency, formatNumber } from "@/utils/formatters";

export default {
  name: "DashboardStatCard",
  props: {
    stat: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formattedValue() {
      const locale = this.$i18n.locale;
      if (this.stat.type === "currency") {
        return formatCurrency(this.stat.value, locale);
      } else if (this.stat.type === "number") {
        return formatNumber(this.stat.value, locale);
      }
      return this.stat.value;
    },
  },
};
</script>
